import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UsersConfirmation from '../components/SignupLogin/UsersConfirmation'
import Omniauth from '../components/SignupLogin/Omniauth'
import Home from '../components/nodes/Home'
import Zoom from '../components/dots/Zoom'
import Noders from '../components/Noder/Noders'
import MenuBar from '../components/fixedComponents/MenuBar'
import Footer from '../components/fixedComponents/Footer'
import About from '../components/fixedComponents/About'
import Help from '../components/fixedComponents/Help'
import LoadingOmniAuth from '../components/SignupLogin/LoadingOmniAuth'
import SignUp from '../components/SignupLogin/SignUp'
import Login from '../components/SignupLogin/Login'
import Logout from '../components/SignupLogin/Logout'
import ForgotPassword from '../components/SignupLogin/ForgotPassword'
import ForgotPasswordEmail from '../components/SignupLogin/ForgotPasswordEmail'
import ResetPassword from '../components/SignupLogin/ResetPassword'
import MyPage from '../components/MyPage/MyPage'
import AfterSignUp from '../components/SignupLogin/AfterSignUp'
import {
  handleMouseDown, handleMouseMove, handleMouseUp,
  setInitialPosition
} from '../actions';
import {isMobile} from 'react-device-detect';
import { Router, Route } from 'react-router-dom'
import history from '../history'
import { CookiesProvider } from 'react-cookie'

export class App extends Component {

  static propTypes = {
    handleMouseDown: PropTypes.func.isRequired,
    handleMouseMove: PropTypes.func.isRequired,
    handleMouseUp: PropTypes.func.isRequired
  }

  render() {
    return (
      <Router history={history}>
        <CookiesProvider>
          <div>
            <MenuBar />
            <Route exact path="/" component={Home} />
            <Route exact path="/nodes" component={Home} />
            <Route path='/nodes/:id' component={Home} />
            <Route exact path="/signup" component={SignUp} />
            <Route exact path="/signup/email" component={AfterSignUp} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/my_page" component={MyPage} />
            <Route exact path="/zoom" component={Zoom} />
            <Route exact path='/users/confirmation/:token' component={UsersConfirmation} />
            <Route exact path='/users/omniauth/:name/:token' component={Omniauth} />
            <Route exact path='/users/password/:token' component={ResetPassword} />
            <Route exact path='/users/facebook' render={()=><LoadingOmniAuth loc={process.env.REACT_APP_NODE_USER_AUTH + "facebook"} />} />
            <Route exact path='/users/twitter' render={()=><LoadingOmniAuth loc={process.env.REACT_APP_NODE_USER_AUTH + "twitter"} />} />
            <Route exact path="/users/forgot" component={ForgotPassword} />
            <Route exact path="/users/forgot/email" component={ForgotPasswordEmail} />
            <Route exact path="/noders/:name" component={Noders} />
            <Route exact path='/about' component={About} />
            <Route exact path='/help' component={Help} />
            <Route exact path='/faq' render={()=><LoadingOmniAuth loc={process.env.REACT_APP_NODE_USER_AUTH + "facebook"} />} />
            <Route exact path='/created_by' render={()=><LoadingOmniAuth loc={process.env.REACT_APP_NODE_USER_AUTH + "facebook"} />} />
            <Footer />
          </div>
        </CookiesProvider>
      </Router>
    );
  };

  componentDidMount() {
    window.addEventListener('mousedown', this.props.handleMouseDown);
    window.addEventListener('mousemove', this.props.handleMouseMove);
    window.addEventListener('touchmove', this.props.handleMouseMove);
    window.addEventListener('mouseup', this.props.handleMouseUp);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.props.handleMouseDown);
    window.removeEventListener('mousemove', this.props.handleMouseMove);
    window.removeEventListener('touchmove', this.props.handleMouseMove);
    window.removeEventListener('mouseup', this.props.handleMouseUp);
  }
}

const mapStateToProps = state => ({
  client: state.client
});

const mapDispatchToProps = {
  handleMouseDown,
  handleMouseMove,
  handleMouseUp,
  setInitialPosition,
};

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/App.js